<template>
  
  <div>
      <b-button class="typo-butt-command mr-1 ml-1 mt-3 but-oval" @click="apriModale"><i class="fas fa fa-1x fa-calendar mr-2"></i>{{$t("pianifica_test_button.text")}}</b-button>
 
      <!-- Pianifica test -->
      <b-modal 
        :hide-footer="footer_hide" 
        ok-only 
        ref="modal" 
        :id="'modal-pianifica-test'+this._uid"
        :title="$t('pianifica_test_modal.title')" 
        :ok-title="$t('pianifica_test_modal.button_salva')" 
        :cancel-title="$t('pianifica_test_modal.button_cancel')" 
        @ok="handleOk" >
        
      <!-- Card test funzionale -->
      <b-card border-variant="white" header-bg-variant="primary" header-text-variant="white" :header="$t('pianifica_test_modal.funzionale')" align="center">
        <b-card-body class="typo-label">
          <b-row>
             <b-col xl="6" lg="6" md="6" sm="6"> 
              <b-row><b-col><div class="float-left"><b>{{$t('pianifica_test_modal.dataora')}}</b></div></b-col></b-row>
              <b-row><b-col><datetime v-model="data_funzionale" type="datetime" class="pull-left mt-1"></datetime></b-col></b-row>
              <b-row><b-col><p class="typo-littleblack pull-left mt-1">{{this.timezoneLocation}}</p></b-col></b-row>

            </b-col>
            <b-col xl="6" lg="6" md="6" sm="6"> 
              <b-row><div class="float-left"><b>{{$t('pianifica_test_modal.periodicita')}}</b></div></b-row>
              <div class="float-left">
                <b-row><b-form-radio class="pull-left" v-model="period_funzionale" name="funzionale_period" value="7">{{$t('pianifica_test_modal.settimanale')}}</b-form-radio></b-row>
                <b-row><b-form-radio class="pull-left" v-model="period_funzionale" name="funzionale_period" value="28">{{$t('pianifica_test_modal.mensile')}}</b-form-radio></b-row>
              </div>
            </b-col> 
          </b-row> 
        </b-card-body>
      </b-card>

      <!-- Card test autonomia -->
      <b-card border-variant="white" header-bg-variant="primary" header-text-variant="white" :header="$t('pianifica_test_modal.autonomia')" align="center">
        <b-card-body class="typo-label">
          <b-row>
            <b-col xl="6" lg="6" md="6" sm="6"> 
              <b-row><b-col><div class="float-left"><b>{{$t('pianifica_test_modal.dataora')}}</b></div></b-col></b-row>
              <b-row><b-col><datetime v-model="data_autonomia" type="datetime" class="pull-left mt-1"></datetime></b-col></b-row>
              <b-row><b-col><p class="typo-littleblack pull-left mt-1">{{this.timezoneLocation}}</p></b-col></b-row>
            </b-col>
            <b-col xl="6" lg="6" md="6" sm="6">  
              <b-row><div class="float-left"><b>{{$t('pianifica_test_modal.periodicita')}}</b></div></b-row>
              <div class="float-left">
                <b-row><b-form-radio class="pull-left" v-model="period_autonomia" name="autonomia_period" value="91">{{$t('pianifica_test_modal.trimestrale')}}</b-form-radio></b-row>
                <b-row><b-form-radio class="pull-left" v-model="period_autonomia" name="autonomia_period" value="182">{{$t('pianifica_test_modal.semestrale')}}</b-form-radio></b-row>
                <b-row><b-form-radio class="pull-left" v-model="period_autonomia" name="autonomia_period" value="365">{{$t('pianifica_test_modal.annuale')}}</b-form-radio></b-row>
                <b-row><b-form-checkbox class="pull-left" v-model="differito" name="check-button" switch>
                  {{$t('pianifica_test_modal.differito')}}
                </b-form-checkbox></b-row>
              </div>
            </b-col> 
          </b-row>  
        </b-card-body>
      </b-card>

       <!-- Alert da utilizzare in caso di errore nell'inserimento dati nel form -->
            <b-alert
              :show="dismissCountDown"
              dismissible
              variant="danger"
              @dismissed="dismissCountDown=0"
              @dismiss-count-down="countDownChanged">
            <p class="typo-label">{{ alertMessage }}</p>
            </b-alert>

      </b-modal>
  </div>

</template>

<script>

import { Datetime } from 'vue-datetime';

export default {
  name: 'PianificaTest',
  data () {
    return {
      footer_hide:false,
      data_funzionale:"",
      data_autonomia:"",
      differito:false,
      period_funzionale:"",
      period_autonomia:"",
      dismissSecs: 5,
      dismissCountDown: 0,
      alertMessage:""
    }
  },
  components: {
    datetime: Datetime
  },
  props:
  {
    sendAction: null,
    cu:null,
    alerts:null,
    timezoneLocation: String
  },
  methods: {
    apriModale() {
      if (this.cu.length>0) 
      {
        console.log("Selezionate", this.cu);
        this.data_funzionale ="";
        this.data_autonomia="";
        this.differito=false;
        this.period_funzionale="28";
        this.period_autonomia="182";
        this.$bvModal.show('modal-pianifica-test'+this._uid);
      }
      else
      {
        var alert = {
          timeLeft: 5,
          state: "danger",
          msg: this.$t('pianifica_test_modal.error_select'),
          countDownChanged: function() {
          }
        }
        this.alerts.push(alert);        
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      this.saveParam();
    },
    saveParam() 
    { 
      var dataFunz= new Date(this.data_funzionale);
      var dataAutonomy=new Date(this.data_autonomia);
      var dataNow=new Date(Date.now());
      if(this.data_funzionale=="" && this.data_autonomia=="")
      {
        this.alertMessage=this.$t("pianifica_test_modal.error_empty");
        this.showAlert(); 
        return false;
      }
      else
      {
        var params ={};
        //check date time functional test
        if(this.data_funzionale!="")
          { 
            if ((dataFunz.getTime() - dataNow.getTime()) / 1000 < 45)
              {
                this.alertMessage=this.$t("pianifica_test_modal.error_date");
                this.showAlert(); 
                return false;
              }
            else
            {
              params.set_functional=this.data_funzionale;
            }
          }
        else
          params.set_functional="";
  
        //check date time autonomy test
        if(this.data_autonomia!="") 
          { 
            if ((dataAutonomy.getTime() - dataNow.getTime()) / 1000 < 45)
              {
                this.alertMessage=this.$t("pianifica_test_modal.error_date");
                this.showAlert(); 
                return false;
              }
            else
            {
              params.set_autonomy=this.data_autonomia;
            }
          }
        else
          params.set_autonomy="";
        
        //set periodicita
        if(this.data_funzionale!="")
        { 
          params.period_functional=this.period_funzionale;
        }
        else
          params.period_functional="";
        
        if(this.data_autonomia!="") 
        {  
          params.period_autonomy=this.period_autonomia;
          params.differito=this.differito;
        }
        else
        {
          params.period_autonomy="";
          params.differito="";
        }
        this.sendAction(params);

        // Hide the modal manually
        this.$nextTick(() => {
            this.$refs.modal.hide()
            })

      }
    },
        
    OnlyHexInString(hex){       
        return !isNaN(Number('0x' + hex))
    }
  }

}
</script>
